<template>
  <div>
    <div class="text-3xl mb-8">Dashboard</div>

    <onboarding class="mb-12"></onboarding>

    <organizer-stats></organizer-stats>

    <!--<stats></stats>-->
  </div>
</template>


<script>
import Onboarding from "@/components/Onboarding";
import OrganizerStats from "@/components/statistics/OrganizerStats";
export default {
  components: { Onboarding, OrganizerStats }
};
</script>
